const KNOWN_ROLE_LABELS: Readonly<Record<string, string>> = {
  "ct-admin": "Davaco Admin",
  "sp-owner": "SP Owner",
  "sp-admin": "SP Admin",
  "sp-employee": "SP Employee",
};

export function roleToLabel(role: string): string {
  if (KNOWN_ROLE_LABELS[role]) {
    return KNOWN_ROLE_LABELS[role];
  }
  return role
    ? role.replace(/-/g, " ")
.replace(/\b\w/g, (c) => c.toUpperCase())
    : "Unknown";
}
